import { ClickTarget, type EventProperties, ImpressionElement, click, impression } from '@tracking';

import type { TrinityAudioEventName } from './types';

const PLAY_CLICKED_TEXT = 'playClicked';
const PAUSE_CLICKED_TEXT = 'pauseClicked';
const PLAYER_READY_TEXT = 'playerReady';
const COMPLETE_TEXT = 'complete';
const RESUME_TEXT = 'resumed';
const ON_FIRST_QUARTILE_TEXT = 'onFirstQuartile';
const ON_MID_POINT_TEXT = 'onMidPoint';
const ON_THIRD_QUARTILE_TEXT = 'onThirdQuartile';

export function trackTrinityAudioPlayerAnalytics(
  eventName: TrinityAudioEventName | string,
  trackEvent: (properties: EventProperties) => void
): void {
  if (eventName === PLAY_CLICKED_TEXT) {
    trackEvent(click({ clickTarget: ClickTarget.TrinityAudio, clickText: 'play' }));
  } else if (eventName === RESUME_TEXT) {
    trackEvent(click({ clickTarget: ClickTarget.TrinityAudio, clickText: 'resume' }));
  } else if (eventName === PAUSE_CLICKED_TEXT) {
    trackEvent(click({ clickTarget: ClickTarget.TrinityAudio, clickText: 'pause' }));
  } else if (eventName === PLAYER_READY_TEXT) {
    trackEvent(click({ clickTarget: ClickTarget.TrinityAudio, clickText: 'player_ready' }));
  } else if (eventName === ON_FIRST_QUARTILE_TEXT) {
    trackEvent(
      impression({
        impressionElement: ImpressionElement.TrinityAudioPlayer,
        context: '25%_completed',
      })
    );
  } else if (eventName === ON_MID_POINT_TEXT) {
    trackEvent(
      impression({
        impressionElement: ImpressionElement.TrinityAudioPlayer,
        context: '50%_completed',
      })
    );
  } else if (eventName === ON_THIRD_QUARTILE_TEXT) {
    trackEvent(
      impression({
        impressionElement: ImpressionElement.TrinityAudioPlayer,
        context: '75%_completed',
      })
    );
  } else if (eventName === COMPLETE_TEXT) {
    trackEvent(
      impression({
        impressionElement: ImpressionElement.TrinityAudioPlayer,
        context: 'completed',
      })
    );
  }
}
